module.exports = __webpack_public_path__ + "static/media/YF82_2.89fae763.jpg";